<template>
    <div class="search inline-block m-b-0">
        <div class="sort-text no-padding pull-left">
            <div class="m-l-sm m-b-0">
                <input aria-label="search" type="text" :placeholder="t_search" v-model="l_search" class="form-control" style="height: 36px;">
            </div>
        </div>

        <div class="search-group no-padding pull-left">
            <div class="m-l-sm m-b-0">
                <chosen-multiselect id="select-groups" class="form-group" :trans-placeholder-multi="t_groups" v-model="l_groups">
                    <option v-for="optiondata in fullGroupList.data"
                            :value="optiondata.id">{{optiondata.name}}</option>
                </chosen-multiselect>
            </div>
        </div>

        <div class="search-location no-padding pull-left">
            <div class="m-l-sm m-b-0">
                <chosen-multiselect id="select-locations" class="form-group" :trans-placeholder-multi="t_locations" v-model="l_locations">
                    <option v-for="optiondata in fullLocationList.data"
                            :value="optiondata.id">{{optiondata.name}}</option>
                </chosen-multiselect>
            </div>
        </div>

        <div class="pull-right">
            <span :data-balloon="t_column + ' / ' + t_filter"
            data-balloon-pos="left"
            data-balloon-length="medium">
                <v-btn aria-label="open" type="button" class="btn btn-secondary m-l-sm" @click.stop.prevent="toggleActions">
                    {{t_options_button}}
                    <i :class="['fa-regular m-l-sm', action_visibility ? 'fa-caret-up' : 'fa-caret-down']"></i>
                </v-btn>
            </span>
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';
    import toaster from "../../common/toaster";

    export default {
        props: [
            'search',
            'groups',
            'locations',
            'action_visibility'
        ],
        data: function () {
            return {
                t_search: Lang.langGet("Search"),
                t_groups: Lang.langChoice('Screengroup|Screengroups', 2),
                t_load_groups_failed: Lang.langGet('Failed to load screengroups.'),
                t_locations: Lang.langChoice('Location|Locations', 2),
                t_load_locations_failed: Lang.langGet('Locations could not be loaded.'),
                t_column: Lang.langGet("Column Preset"),
                t_filter: Lang.langGet("Filter"),
                t_deprecated_options: Lang.langGet("More Options"),
                t_hide_deprecated_options: Lang.langGet('Less Options'),
                t_options_button: '',

                l_search: this.search,
                l_groups: this.groups,
                l_locations: this.locations,

                fullGroupList: {
                    data: []
                },
                fullLocationList: {
                    data: []
                },
            }
        },
        watch: {
            l_search: debounce(function () {
                this.$emit('update:search', this.l_search);
                EaseEventBus.fire('triggerUpdateTable');
            }, 250),
            l_groups: function () {
                this.$emit('update:groups', this.l_groups);
                EaseEventBus.fire('triggerUpdateTable');
            },
            l_locations: function () {
                this.$emit('update:locations', this.l_locations);
                EaseEventBus.fire('triggerUpdateTable');
            },
        },
        methods: {
            loadGroups: function () {
                if (this.fullGroupList.data.length > 0) {
                    return;
                }

                axios.post('/administration/project/loadscreengroups', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.fullGroupList.data = response.data.data;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                    toaster.error(this.t_load_groups_failed);
                });
            },
            loadLocations: function () {
                if (this.fullLocationList.data.length > 0) {
                    return;
                }

                axios.post('/administration/project/loadlocations', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.fullLocationList.data = response.data.data;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                    toaster.error(this.t_load_locations_failed);
                });
            },
            toggleActions: function() {
                this.t_options_button = !this.action_visibility ? this.t_hide_deprecated_options : this.t_deprecated_options;
                this.$emit('update:action_visibility', !this.action_visibility);
            }
        },
        mounted() {
            this.loadGroups();
            this.loadLocations();
            this.t_options_button = this.action_visibility ? this.t_hide_deprecated_options : this.t_deprecated_options;

            EaseEventBus.listen('FilterOrPresetWasSetClientStatus', () => {
                this.t_options_button = this.t_hide_deprecated_options;
            });
        }
    }
</script>

<style scoped>
    .inline-block {
        padding-right: 10pt;
    }

    .search .search-group {
        width: 350px;
    }
    .search .search-location {
        width: 350px;
    }

</style>
